import React from 'react';
import PropTypes from 'prop-types';
import { pureRender } from 'epic-alt-utils/index';
import NavActions from '../../actions';

@pureRender
export default class PropertyLogo extends React.Component {
    static propTypes = {
        logoLink: PropTypes.object,
        searchActive: PropTypes.bool
    };

    static contextTypes = {
        isTablet: PropTypes.bool,
        globalLinkOnClick: PropTypes.func
    };

    logoClick = (e) => {
        const href = this.props.logoLink ? this.props.logoLink.href : '#';
        let globalReturnValue = null;
        if (this.context.globalLinkOnClick && typeof this.context.globalLinkOnClick === 'function') {
            globalReturnValue = this.context.globalLinkOnClick(e, href);
        }

        if (globalReturnValue !== false) {
            if (this.props.logoLink && this.props.logoLink.onClick && typeof this.props.logoLink.onClick === 'function') {
                this.props.logoLink.onClick(e);
            }
        }

        NavActions.closeMobileTablet.defer();
    };

    render() {
        const href = this.props.logoLink ? this.props.logoLink.href : '#';

        return (
            <a //eslint-disable-line jsx-a11y/anchor-has-content
                role="button"
                id="propLogo"
                href={href}
                className={`propLogo ${this.context.isTablet ? 'tablet' : ''} ${this.props.searchActive ? 'search-active' : ''}`}
                onClick={this.logoClick} />
        );
    }
}



// WEBPACK FOOTER //
// ./app/scripts/components/propertyLogo/PropertyLogo.js